/**
 * @generated SignedSource<<ec5d1429b6bc8aa29206c4a7f0299f79>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type RootConnectionRegister$data = {
  readonly __id: string;
  readonly edges: ReadonlyArray<{
    readonly __typename: "JiraIssueEdge";
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "RootConnectionRegister";
};
export type RootConnectionRegister$key = {
  readonly " $data"?: RootConnectionRegister$data;
  readonly " $fragmentSpreads": FragmentRefs<"RootConnectionRegister">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "RootConnectionRegister",
  "selections": [
    {
      "concreteType": "JiraIssueEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "__typename"
        }
      ]
    },
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "kind": "ScalarField",
          "name": "__id"
        }
      ]
    }
  ],
  "type": "JiraIssueConnection"
};

(node as any).hash = "2b16ecb2b05570b21f8d4dc859600431";

export default node;
